import { useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";

function ModalDesaprobar({ idServicio, onDesaprobado }) {
    const [razon, setRazon] = useState("");
    const [show, setShow] = useState(false);
    const [enviando, setEnviando] = useState(false);
    const [mostrarCambio, setMostrarCambio] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => { setRazon(""); setShow(true); };

    async function confirmar() {
        if (!razon.trim()) return;
        try {
            setEnviando(true);
            const res = await axios.post("/desaprobar-servicio-admin", {
                params: { idServicio, mensajeRevision: razon.trim() },
            });
            if (res.data.exito) {
                handleClose();
                Swal.fire({ icon: "success", title: "Desaprobado", text: "El servicio fue desaprobado y se notificó al proveedor.", confirmButtonColor: "var(--azul-logo-fondo)", timer: 2500, showConfirmButton: false });
                if (onDesaprobado) onDesaprobado(razon.trim());
            } else {
                Swal.fire({ icon: "error", title: "Error", text: res.data.mensaje || "No se pudo desaprobar.", confirmButtonColor: "var(--azul-logo-fondo)" });
            }
        } catch {
            Swal.fire({ icon: "error", title: "Error", text: "Ocurrió un error al desaprobar el servicio.", confirmButtonColor: "var(--azul-logo-fondo)" });
        } finally {
            setEnviando(false);
        }
    }

    return (
        <>
            <button
                type="button"
                className="btn btn-outline-danger btn-sm rounded-3"
                onClick={handleShow}
            >
                <i className="bi bi-x-circle me-1"></i>Desaprobar
            </button>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="fw-bold fs-5">Desaprobar servicio</Modal.Title>
                </Modal.Header>
                <Modal.Body className="pt-2 pb-0">
                    <p className="text-muted small mb-3">
                        Indica al proveedor por qué su servicio no fue aprobado. Este mensaje le llegará por correo y aparecerá en su perfil.
                    </p>
                    <label className="form-label fw-semibold small">Razón de desaprobación</label>
                    <textarea
                        className="form-control rounded-3"
                        rows={4}
                        placeholder="Ej: Las imágenes del servicio no cumplen con los estándares mínimos de calidad requeridos..."
                        value={razon}
                        onChange={e => setRazon(e.target.value)}
                        maxLength={2000}
                    />
                    <div className="text-end mt-1">
                        <span className="text-muted" style={{ fontSize: "0.75rem" }}>{razon.length}/2000</span>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-0 pt-3">
                    <button type="button" className="btn btn-outline-secondary btn-sm rounded-3" onClick={handleClose} disabled={enviando}>
                        Cancelar
                    </button>
                    <button
                        type="button"
                        className="btn btn-danger btn-sm rounded-3 fw-semibold"
                        onClick={confirmar}
                        disabled={!razon.trim() || enviando}
                    >
                        {enviando
                            ? <><span className="spinner-border spinner-border-sm me-2" role="status" />Desaprobando...</>
                            : <><i className="bi bi-x-circle me-1"></i>Desaprobar</>
                        }
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ModalDesaprobar;
